module.exports = __webpack_public_path__ + "static/media/fileload.ac447129.gif";